import { MouseClickRightSvg } from "@lhd/assets";

export const useColumns = () => {
  return [
    {
      columnId: COLUMNS_DEFINED.index,
      label: "No.",
      type: "text",
      width: 30,
      editable: false,
      icon: <></>,
    },
    {
      headerName: "事業所名",
      field: COLUMNS_DEFINED.name,
      width: 230,
      type: "text",
      icon: <></>,
    },
    {
      headerName: "ステーションID",
      field: COLUMNS_DEFINED.station_id,
      width: 160,
      type: "text",
      icon: <></>,
    },
    {
      headerName: "法人番号",
      field: COLUMNS_DEFINED.co_number,
      width: 160,
      type: "text",
      icon: <></>,
    },
    {
      headerName: "役員名",
      field: COLUMNS_DEFINED.ceo_name,
      width: 160,
      type: "text",
      icon: <></>,
    },
    {
      headerName: "郵便番号",
      field: COLUMNS_DEFINED.zipcode,
      width: 160,
      type: "text",
      icon: <></>,
    },
    {
      headerName: "住所",
      field: COLUMNS_DEFINED.address,
      width: 160,
      type: "text",
      icon: <></>,
    },
    {
      label: "事業の種類",
      columnId: COLUMNS_DEFINED.industry_category_id,
      width: 160,
      type: "text",
      icon: <MouseClickRightSvg />,
    },
  ];
};

export const initialDataItem: any = {
  name: "",
  station_id: "",
  co_number: "",
  ceo_name: "",
  zipcode: "",
  address: "",
  industry_category_name: "",
  industry_category_id: "",
};

export const handleData = (data: any[]) => {
  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_) => initialDataItem),
  ];
};

export const checkInvalid = (
  data: any,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      if (!data?.[fieldItem as keyof any]) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      if (!data?.[keyItem as keyof any]) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const convertRawItem = (item: any) => ({
  id: item.id,
  company_id: item.company_id,
  name: item.name || "",
  station_id: item.station_id,
  ceo_name: item.ceo_name || "",
  co_number: item.co_number || "",
  address: item.address || "",
  zipcode: item.zipcode || "",
  industry_category_name: item?.industry_category_name || "",
  industry_category_id: item?.industry_category_id || "",
});

export const customer_sheet_fields_convert_attr = ["status", "category"];
export const FILTER_FIELDS = [
  "name",
  "station_id",
  "co_number",
  "ceo_name",
  "address",
  "zipcode",
  "industry_category_id",
];
export const COLUMNS_DEFINED = {
  index: "index",
  name: "name",
  station_id: "station_id",
  co_number: "co_number",
  ceo_name: "ceo_name",
  address: "address",
  zipcode: "zipcode",
  industry_category_id: "industry_category_id",
  industry_category_name: "industry_category_name",
};

export const REQUIRED_FIELDS = [COLUMNS_DEFINED.name];
